/* global updateButtonByCheckAllRequiredValues, updateSubmitButton */
/*
  [validationの使い方]
  1. formの中身のwrapper要素に#form_validatedを追加する。
  2. validationを追加したいformの要素に.requiredを追加する。
  3. submitするボタン要素に.submit_triggerを追加する。
*/
import axios from 'axios';

const PHONE_NUMBER_REGEX = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/;

window.addEventListener('load', () => {
  const form_validated = document.getElementById('form_validated');
  if (!form_validated) {
    return;
  }
  const requireds = document.getElementsByClassName('required');
  const childCategorySelect = document.getElementById('item_child_category_id');
  const childCategoryRequired = childCategorySelect.getAttribute('data-child');
  const itemTel = document.getElementById('item_tel');
  Array.prototype.forEach.call(requireds, (node) => { registerOnChangeEvent(node); });
  // 子カテゴリが必要な場合
  if (childCategoryRequired) {
    childCategorySelect.classList.add('required', 'first_step_required');
  }
  // ロード後にチェックをかけて最初から埋まっていた場合をカバーする。
  updateButtonByCheckAllRequiredValues();
  registerOnChangeEvent(childCategorySelect);

  if (itemTel) {
    registerOnChangeEvent(itemTel);
    togglePhoneNumberCheckIcon(itemTel);
  }
});

// direct_upload.js, item_new_cashed_images_handler.jsからも呼び出す関数
window.updateButtonByCheckAllRequiredValues = function() {
  // 全てのrequiredを再度取得して全部にvalueがあるかのチェック。
  const requires = document.getElementsByClassName('required');
  const image_require_parent = document.getElementsByClassName('image_required');
  let valid = false;
  for( let i = 0; i < requires.length; i++ ){
    const node = requires[i];

    if (node.value == '' || node.id == 'user_password' && node.value.length < 6) {
      valid = false;
      break;
    } else {
      valid = true;
    }
  }

  // 電話番号のチェック
  const phoneNumberInput = document.getElementById('item_tel');
  if (phoneNumberInput !== null && !(phoneNumberInput.value.match(PHONE_NUMBER_REGEX))){
    valid = false;
  }

  // 郵便番号のチェック
  const postalCodeInput = document.getElementById('user_postal_code');
  if (postalCodeInput !== null && postalCodeInput.value !== '' && postalCodeInput.value.length !== 7) {
    valid = false;
  }

  // 画像のチェック
  // 画像は任意のときは、image_require_parent[0]が存在しない
  if (image_require_parent[0]) {
    // 戻るボタンで戻ってきた時には必須項目は二番目の要素を確認する
    const image_requires = image_require_parent.length > 1 && image_require_parent[0].children.length == 0 ? image_require_parent[1].children : image_require_parent[0].children;
    // validがtrueかつ、画像が1枚以上存在するかチェック
    if (valid && image_requires.length > 0 && image_requires.value != '') {
      valid = true;
    } else {
      valid = false;
    }
  }

  updateSubmitButton(valid);
};

function getChildCategory(parent_category_id) {
  const childCategorySelect = document.getElementById('item_child_category_id');
  axios.get(`/pix/api/public/categories?parent_category_id=${parent_category_id}`).then(
    (res) => {
      if (res.data.length > 0) {
        // 子カテゴリが存在しているため、requiredを追加。
        childCategorySelect.classList.add('required', 'first_step_required');
        // onchangeEventを登録。
        registerOnChangeEvent(childCategorySelect);
        updateButtonByCheckAllRequiredValues();
      } else {
        // 子カテゴリが存在してない。requiredを削除。
        childCategorySelect.classList.remove('required', 'first_step_required');
        updateButtonByCheckAllRequiredValues();
      }
    }
  );
  // axios.getのthenは非同期なのでここで処理を完結させる
  return;
}

function registerOnChangeEvent(node) {
  if (!node) {
    return;
  }

  node.addEventListener("keyup", (e) => {
    checkAllRequiredValues(e);
  });
  node.addEventListener('change', (e) => {
    checkAllRequiredValues(e);
  });

  const checkAllRequiredValues = function(e) {

    if (e.target.value) {
      // もし親カテゴリが変更された場合
      if (e.target.id == 'item_parent_category_id') {
        getChildCategory(e.target.value);
      }
    }
    // 戻るボタンで子カテゴリが埋まった状態でloadされた後子カテゴリに制限を追加する。
    if (e.target.id == 'item_child_category_id') {
      const childCategorySelect = document.getElementById('item_child_category_id');
      childCategorySelect.classList.add('required');
    }
    updateButtonByCheckAllRequiredValues();
  };
}

// direct_upload.jsからも呼び出す関数
// アップロード中は査定依頼ボタンを押せないようにするため
window.updateSubmitButton = function(activate) {
  const form_validated = document.getElementById('form_validated');
  if (!form_validated) {
    return;
  }
  const submit_trigger = document.getElementsByClassName('submit_trigger');
  const unactivatedClass = 'bg_clr_btn_noactive';
  const activatedClass = 'bg_clr_cyan';
  const attentionMessage = document.getElementById('attention_message');
  const submitButton = submit_trigger[0];
  submitButton.classList.add(activate ? activatedClass : unactivatedClass);
  submitButton.classList.remove(activate ? unactivatedClass : activatedClass);
  if (activate) {
    submitButton.removeAttribute("disabled");
  } else {
    submitButton.setAttribute("disabled", true);
  }

  const itemFormWithTwoStep = submitButton.innerText == '次へ';
  const toNextImage = document.getElementById('toNextImage');
  if (itemFormWithTwoStep && activate) {
    attentionMessage.classList.add('display_none');
    toNextImage.classList.remove('display_none');
  } else{
    attentionMessage.classList.remove('display_none');
    toNextImage.classList.add('display_none');
  }
};

window.addEventListener('load', () => {
  const form_validated = document.getElementById('form_validated');
  if (!form_validated) {
    return;
  }
  window.addEventListener("keyup", (e) => {
    toggleFormCheckIcon(e);
  });

  window.addEventListener("change", (e) => {
    toggleSelectCheckIcon(e);
  });

  // カテゴリ選択部分が`window.addEventListener("change"...`だとなぜか効かないので
  // 追加
  document.querySelector('#item_parent_category_id').addEventListener('change', (e) => {
    toggleSelectCheckIcon(e);
  });

  document.querySelector('#item_child_category_id').addEventListener('change', (e) => {
    toggleSelectCheckIcon(e);
  });

  if (document.getElementById('item_sex')) {
    document.querySelector('#item_sex').addEventListener('change', (e) => {
      toggleSelectCheckIcon(e);
    });
  }

  if (document.getElementById('item_job')) {
    document.querySelector('#item_job').addEventListener('change', (e) => {
      toggleSelectCheckIcon(e);
    });
  }

  if (document.querySelector('#birth_year') && document.querySelector('#birth_month') && document.querySelector('#birth_day')) {
    document.querySelector('#birth_year').addEventListener('change', (e) => {
      toggleSelectCheckIcon(e);
    });
    document.querySelector('#birth_month').addEventListener('change', (e) => {
      toggleSelectCheckIcon(e);
    });
    document.querySelector('#birth_day').addEventListener('change', (e) => {
      toggleSelectCheckIcon(e);
    });
  }
});
function toggleFormFullNameCheckIcon(e) {
  const checkFullName = document.getElementsByClassName('full_name_check_icon');
  const otherHalfNameId = e.target.id == 'item_last_name' ? 'item_first_name' : 'item_last_name';
  const otherHalfName = document.getElementById(otherHalfNameId).value;
  if (e.target.value != '' && otherHalfName != '') {
    checkFullName[0].classList.remove('hidden');
  } else {
    checkFullName[0].classList.add('hidden');
  }
}
function toggleFormCheckIcon(e) {
  if (e.target.id == 'item_last_name' || e.target.id == 'item_first_name') {
    toggleFormFullNameCheckIcon(e);
    return;
  }
  if (e.target.id == 'user_postal_code') {
    togglePostalCodeCheckIcon(e);
    return;
  }

  if (e.target.id == 'item_tel') {
    togglePhoneNumberCheckIcon(e);
    return;
  }

  const haveValue = e.target.value != '';
  const checkIcon = e.target.parentElement.nextElementSibling;

  if (haveValue) {
    checkIcon.classList.remove('hidden');
  } else {
    checkIcon.classList.add('hidden');
  }
}

function toggleSelectCheckIcon(e) {
  if (e.target.tagName != 'SELECT') {
    return;
  }

  let haveValue = false;
  let checkIcon = '';

  if (e.target.id.includes('birth_')) {
    const year = document.getElementById('birth_year').value;
    const month = document.getElementById('birth_month').value;
    const day = document.getElementById('birth_day').value;
    haveValue = (year && month && day);
    checkIcon = document.getElementById('birthdayCheckIcon');
  } else {
    haveValue = e.target.selectedOptions[0].value != '';
    checkIcon = e.target.parentElement.nextElementSibling;
  }

  if (haveValue) {
    checkIcon.classList.remove('hidden');
  } else {
    checkIcon.classList.add('hidden');
  }
}

function togglePostalCodeCheckIcon(e) {
  const valid = e.target.value.match(/\d{7}/);
  const checkIcon = e.target.parentElement.nextElementSibling;

  if (valid) {
    checkIcon.classList.remove('hidden');
  } else {
    checkIcon.classList.add('hidden');
  }
}

function togglePhoneNumberCheckIcon(e) {
  let valid = false;
  let checkIcon = null;
  // eがイベントならtarget.valueを処理する
  // eがエレメントならそのままvalueを処理する
  if(e.target === undefined){
    valid = e.value.match(PHONE_NUMBER_REGEX);
    checkIcon = e.parentElement.nextElementSibling;
  }else{
    valid = e.target.value.match(PHONE_NUMBER_REGEX);
    checkIcon = e.target.parentElement.nextElementSibling;
  }

  if (valid) {
    checkIcon.classList.remove('hidden');
  } else {
    checkIcon.classList.add('hidden');
  }
}
